import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ScoopButton, ScoopText } from '../../ui'
import { ROUTES } from '../../../router/routes'
import { XCircleIcon } from '@phosphor-icons/react'
import styles from './BillingFlow.module.scss'

/**
 * Cancel page shown when user cancels Chargebee checkout.
 */
export const Cancel = () => {
    const navigate = useNavigate()

    return (
        <div className={styles.pageContainer}>
            <div className={styles.card}>
                <XCircleIcon size={64} weight="fill" className={styles.cancelIcon} />
                <ScoopText className={styles.title}>Checkout Cancelled</ScoopText>
                <ScoopText className={styles.message}>
                    No charges were made to your account. You can upgrade anytime from your Account
                    settings.
                </ScoopText>
                <div className={styles.buttonGroup}>
                    <ScoopButton variant="outlined" onClick={() => navigate(ROUTES.ACCOUNT)}>
                        Return to Account Settings
                    </ScoopButton>
                    <ScoopButton variant="contained" onClick={() => navigate(ROUTES.INSIGHTS)}>
                        Chat with you data
                    </ScoopButton>
                </div>
            </div>
        </div>
    )
}
